import React from 'react';
import debug from 'debug';
import { useLocation } from 'react-router';

const log = debug('exchange:core');

export default (Component) => {
  const WithFocusRestore = (props) => {
    const location = useLocation();

    React.useEffect(() => {
      const skipLinksElement = global.document.getElementById('skip-links');

      // Move focus to the skip-links container (a `tabindex="-1"` wrapper),
      // NOT the first skip link itself. The wrapper is not visually rendered,
      // so focusing it restores focus to the top of the document on load /
      // route change without flashing the skip-link pill. Because the wrapper
      // is first in DOM order, the user's next Tab lands on the first skip
      // link, which then reveals itself via `show-on-focus` — i.e. the bypass
      // control appears on demand (when tabbing), not by default on refresh.
      const focusSkipLinksContainer = () => {
        if (
          skipLinksElement &&
          global.document.activeElement !== skipLinksElement
        ) {
          log('focusing skip links');
          skipLinksElement.focus();
        }
      };

      focusSkipLinksContainer();
      // SkipLinks portals into #skip-links from componentDidMount; retry once
      // after children have a chance to render.
      const timeoutId = setTimeout(focusSkipLinksContainer, 100);

      return () => clearTimeout(timeoutId);
    }, [location?.pathname]);

    return <Component {...props} />;
  };

  const name = Component.displayName || Component.name;

  WithFocusRestore.displayName = name
    ? `WithFocusRestore(${name})`
    : 'WithFocusRestore';

  return WithFocusRestore;
};
